import { PopoverOrigin } from '@mui/material';

export const HOST_API = process.env.REACT_APP_HOST_API;
export const HOST_VIDEO_API = process.env.REACT_APP_HOST_VIDEO_API;
export const HOST_APP = process.env.REACT_APP_HOST_APP;
export const HOST_PUBLIC_APP = process.env.REACT_APP_HOST_PUBLIC_APP;
export const HOST_CLIENT_APP = process.env.REACT_APP_HOST_CLIENT_APP;
export const HOST_NOTIFICATIONS = process.env.REACT_APP_HOST_NOTIFICATIONS;
export const HOST_PUBLIC_NOTIFICATIONS = process.env.REACT_APP_HOST_PUBLIC_NOTIFICATIONS;
export const HOST_ANALYTICS = process.env.REACT_APP_HOST_ANALYTICS;
export const HOST_COMMENTS = process.env.REACT_APP_HOST_COMMENTS;
export const HOST_PUBLIC_COMMENTS = process.env.REACT_APP_HOST_PUBLIC_COMMENTS;
export const HOST_PHOTO = process.env.REACT_APP_HOST_PHOTO;
export const HOST_GET_PHOTO = process.env.REACT_APP_HOST_GET_PHOTO;
export const HOST_GET_AVATAR = process.env.REACT_APP_HOST_GET_AVATAR;
export const HOST_EVENT = process.env.REACT_APP_HOST_EVENT;
export const HOST_FIND_API = process.env.REACT_APP_HOST_FIND_API;

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 274,
  DASHBOARD_COLLAPSE_WIDTH: 72,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const paymentStatuses: Record<number, [string, string]> = {
  1: ['Оплачено', '#2E7D32'],
  2: ['Не оплачено', '#0288D1'],
  3: ['Отменен', '#D32F2F'],
  4: ['Отменен', '#D32F2F'],
  5: ['Заморожен', '#000000DE'],
};

export const INITIAL_PER_PAGE = 25;
export const PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const PER_PAGE_OPTIONS_ALL = [...PER_PAGE_OPTIONS, { value: -1, label: 'Все' }];
export const INITIAL_LIST_PARAMS = { per_page: INITIAL_PER_PAGE };

export const NAME_REGEX = /^[a-zA-Z|а-яА-Я|ё|Ё]+$/;
export const FIRST_NAME_MAX_LENGTH = 30;
export const SECOND_NAME_MAX_LENGTH = 30;

export const DEFAULT_FREEZE_COMMENT_ERROR = 'Введите комментарий';
export const MIN_CLIENT_FREEZE_DAYS = 7; // week
export const MAX_CLIENT_FREEZE_DAYS = 3650; // 10 years
export const MIN_CLIENT_FREEZE_COMMENT = 6;
export const MAX_CLIENT_FREEZE_COMMENT = 255;
export const CLIENT_FREEZE_REGEX = /[^a-zA-Zа-яА-Я\s\d.,?!«»:;()\-–—*+=]/g;

export const DEFAULT_FAQ_QUESTION_ERROR = 'Введите вопрос';
export const DEFAULT_FAQ_ANSWER_ERROR = 'Введите ответ';
export const FAQ_REGEX = CLIENT_FREEZE_REGEX;
export const MIN_FAQ_QUESTION = MIN_CLIENT_FREEZE_COMMENT;
export const MAX_FAQ_QUESTION = MAX_CLIENT_FREEZE_COMMENT;
export const MIN_FAQ_ANSWER = 10;
export const MAX_FAQ_ANSWER = MAX_CLIENT_FREEZE_COMMENT;

export const SEARCH_REGEX = /[^a-zA-Zа-яА-Я0-9ёЁ@.%+-_\s]|(\s{2,})/g;

export const COUNTRY_REGEX = /^[a-zA-Z|а-яА-Я|ё|Ё|\s]+$/;

export const CLIENTS_DECLINATION = {
  one: 'пользователь',
  two: 'пользователя',
  five: 'пользователей',
};

export type PaymentTypes = 'yookassa' | 'robokassa' | 'manual' | 'present';

export const controlsOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
} as PopoverOrigin;

export enum CourseTypes {
  COURSE = 1,
  WORKOUT = 2,
  COMPLEX = 3,
  BROADCAST = 4,
  /** @deprecated Старая структура марафонов, будет заменена */
  MARATHON = 5,
  CHALLENGE = 6,
  TUTORIAL = 7,
}

export enum Statuses {
  idle = 'idle',
  loading = 'loading',
  succeeded = 'succeeded',
  failed = 'failed',
}
